window.serendis.resultsChartSubjectPercentages = function($chart, data) {

	// PlotlinesY
	var ticks = window.serendis.answerOptions.length,
		plotLinesY = [];
	for (var i = 0; i < window.serendis.normalisedMax / ticks; i ++) {
		plotLinesY.push({
			color:'rgba(0,0,0,0.1)',
			width: 1,
			value: (i + 1) * ticks,
			zIndex:20
		});
	}
	plotLinesY.push({
		color: '#0f73a7',
		width: 1,
		value: 15 / window.serendis.normalisedMax * 100,
		dashStyle:'LongDash',
		zIndex:30
	})

	// Series
	var series = [];

	// Data
	var points = [];
	for (var i = 0; i < data.options.length; i ++) {
		points.push(data.options[i].percent);
	}

	// Options counts
	series.push({
		type: 'bar',
		name: 'Answers',
		data: points,
		color:data.color,
		grouping:false,
		xAxis:0,
		lineWidth:0,
		zIndex:6
	});

	// Create chart
	Highcharts.chart($chart.attr('id'), {

		chart: {
			polar: false,
			type:'bar',
			renderTo:$chart.attr('id'),
			backgroundColor:'rgba(255, 255, 255, 0.0)',
			// margin: [30,40,40,40]
		},

		legend:false,
		credits:false,
		title:false,
		tooltip: {
			enabled:false,
			animation:false,
		},

		pane:{
			size: '100%',
		},

		xAxis: {
			categories: window.serendis.answerOptions,
			labels: {
				distance:10,
				style: {
					color:'#444444',
					fontSize:'8px'
				},
				zIndex:7
			},
			// lineWidth:0,
			// gridLineColor:'#eaeaea',
			// gridZIndex:2
		},
		yAxis: {
			max:100,
			min:0,
			showLastLabel: true,
			labels: {
				enabled:false,
				formatter: function() {
				    return this.value + '%';
				},
			},
			// tickInterval:ticks,
			// gridLineColor:'rgba(255, 255, 255, 0.0)',
			// plotLines: plotLinesY,
			title: {
				enabled:false
			}
		},
		plotOptions: {
			series: {
				pointStart: 0,
				states: {
					hover: {
						enabled: true
					}
				}
			},
			bar: {
				pointPadding: 0,
				groupPadding: 0.04,
				dataLabels: {
					enabled:true,
					formatter: function() {
					    return this.y + '%';
					},
					style: {
						color:'#444444',
						fontSize:'10px',
						fontWeight:'normal'
					},
				}
			}
		},
		series: series
	});

};